export const SERVER_URL = "https://api.yumme.ca/";